module.exports = __webpack_public_path__ + "img/login_bg.552dac7d.jpg";